{
  "version": 1,
  "asset_id": "d169f8ca-c14f-4a73-a4cf-59e6cbcc4b6d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/d169f8ca-c14f-4a73-a4cf-59e6cbcc4b6d/loc-cedar-park-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/d169f8ca-c14f-4a73-a4cf-59e6cbcc4b6d/loc-cedar-park-640.avif",
  "original_filename": "loc-cedar-park-640.avif",
  "size": 27656,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:20Z"
}
